export default __webpack_public_path__ + "static/media/practo2.80345611.png";